import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { baseURL } from "../../globalUtils/axiosConfig";
// import { fetchDocumentField, fetchDocumentFieldSuccess } from "../DefaultDocumentFields/redux/actions";
// import { fetchDocStatuses, fetchDocStatusesSuccess } from "../DocumentStatuses/redux/actions";
import { fetchMaterialTypes, fetchBoltTypes } from '../materialTypes/redux/actions';
import { fetchAllTemplates } from "../materialTemplates/redux/actions";
import { fetchRevisionStatuses, fetchRevisionStatusesSuccess } from "../RevisionStatuses/redux/actions";
import { fetchMaterialControl, fetchProjectActivitiesSuccess } from "./redux/actions";
import GraphSection from "./graphSection";
import ProjectsTableSection from "./tableSection";

const Projects = () => {
  const [materialTemplateCheckList, setMaterialTemplateCheckList] = useState([]);
  const [materialTemplateOptions, setMaterialTemplateOptions] = useState([]);
  const [statusCheckList, setStatusCheckList] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [projectDetails, setProjectDetails] = useState(null);
  const [searchResultIds, setSearchResultIds] = useState([]);
  const { allTemplates } = useSelector((state) => state.materialTemplatesReducer);
  const dispatch = useDispatch();
  const { project_id } = useParams();

  const fetchProjectDetails = async () => {
    if (!project_id) {
      return;
    }
    
    try {
      const res = await axios.get(`${baseURL}/project/${project_id}`);
      
      if (res.status === 200) {
        if (res.data && res.data.data) {
          setProjectDetails(res.data.data);
        } else if (res.data) {
          setProjectDetails(res.data);
        }
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    if (project_id) {
      fetchProjectDetails();
    }
  }, [project_id]);

  useEffect(() => {
    dispatch(fetchAllTemplates({ search: {} }));
    dispatch(fetchMaterialTypes());
    dispatch(fetchBoltTypes());
    
    // Dummy data for document statuses
    const dummyStatuses = [
      { id: 1, status_name: "Draft", status_color: "#FFA500", status_order: 1 },
      { id: 2, status_name: "In Review", status_color: "#0000FF", status_order: 2 },
      { id: 3, status_name: "Approved", status_color: "#008000", status_order: 3 },
      { id: 4, status_name: "Rejected", status_color: "#FF0000", status_order: 4 },
      { id: 5, status_name: "Obsolete", status_color: "#808080", status_order: 5 }
    ];
    
    // Dummy data for revision statuses
    const dummyRevisionStatuses = [
      { id: 1, status_name: "A", status_order: 1 },
      { id: 2, status_name: "B", status_order: 2 },
      { id: 3, status_name: "C", status_order: 3 },
      { id: 4, status_name: "D", status_order: 4 },
      { id: 5, status_name: "E", status_order: 5 }
    ];
    
    // Fetch material control data from API if project_id exists
    if (project_id) {
      dispatch(fetchMaterialControl({   
        projectId: project_id,
       }));
    }
    
    // Dummy data for project activities
    const dummyProjectActivities = {
      activities: [
        {
          id: 201,
          activity_date: new Date().toISOString(),
          activity_type: "document_created",
          description: "Project Plan document created",
          user: { id: 1, first_name: "John", surname: "Doe" },
          document_id: 101
        },
        {
          id: 202,
          activity_date: new Date(new Date().setDate(new Date().getDate() - 5)).toISOString(),
          activity_type: "document_created",
          description: "Technical Specification document created",
          user: { id: 2, first_name: "Jane", surname: "Smith" },
          document_id: 102
        },
        {
          id: 203,
          activity_date: new Date(new Date().setDate(new Date().getDate() - 10)).toISOString(),
          activity_type: "document_created",
          description: "Quality Control Report document created",
          user: { id: 3, first_name: "Robert", surname: "Johnson" },
          document_id: 103
        }
      ],
      total_activities: 3
    };
    
    // For revisionStatusReducer - expects direct array
    dispatch(fetchRevisionStatusesSuccess({ statuses: dummyStatuses, total_revision_statuses: dummyStatuses.length }));
    
    // For ProjectsReducer - expects object with documents, total_documents, permissions
    // Create dummy permissions object with all permissions set to true
    const dummyPermissions = {
      document_control: {
        add_edit: true,
        view: true,
        export: true,
        delete: true,
      },
      distribution: { add_edit: true, view: true, delete: true },
      revisions: { add_edit: true, view: true, delete: true },
    };
    
    // Only set permissions - actual material control data will come from API
    dispatch(fetchMaterialControl({ 
      documents: [], 
      total_documents: 0,
      permissions: dummyPermissions,
      projectId: project_id
    }));
    
    // For ProjectsReducer - expects object with activities, total_activities
    dispatch(fetchProjectActivitiesSuccess(dummyProjectActivities));
    
    // Load dummy data instead of API calls
  }, []);

  useEffect(() => {
    if (allTemplates && Array.isArray(allTemplates)) {
      let materialOptions = allTemplates.map((el) => {
        const { name, id } = el;
        return { value: id, label: name };
      });
      setMaterialTemplateOptions(materialOptions);
    }
  }, [allTemplates]);


  // Effect for handling project details updates
  useEffect(() => {
    // React to changes in projectDetails or project_id
  }, [projectDetails, project_id]);

  return (
    <div className="page-top-div">
      <>
        <span className="text-span" style={{ lineHeight: "17px" }}>
          MATERIAL CONTROL - {projectDetails?.projectNumber ? projectDetails.projectNumber.replace("-", "") : "Loading..."}
        </span>
        <GraphSection project_id={project_id} searchResultIds={searchResultIds} />
      </>
      <ProjectsTableSection
        materialTypeCheckList={materialTemplateCheckList}
        setMaterialTypeCheckList={setMaterialTemplateCheckList}
        materialTypeOptions={materialTemplateOptions}
        statusCheckList={statusCheckList}
        setStatusCheckList={setStatusCheckList}
        statusOptions={statusOptions}
        project_id={project_id}
        setSearchResultIds={setSearchResultIds}
      />
     
    </div>
  );
};

export default Projects;
